import { DecimalPipe } from '@angular/common';
import { ColumnOutputType } from 'app/component-library/table/column-output-type';
import { TableColumn } from 'app/component-library/table/table-column';
import { CONFIG } from 'app/core/config';
import { DateTimeFormatterPipe } from 'app/shared/pipes/date-time-formatter.pipe';
import { Widget } from 'app/viewmodels/dashboard/widget';
import { WidgetParameter } from 'app/viewmodels/dashboard/widget-parameter';
import { DisplayData } from '../bar/DisplayData';
import { MitigationDays } from '../widget-parameters/mitigation-days';
import { ValueSource } from '../widget-parameters/value-source.enum';
import { ValueType } from '../widget-parameters/value-type.enum';
import { ItemizedWidgetData } from './itemized-widget-data';

export abstract class MitigationItemizedWidgetData extends ItemizedWidgetData {
  protected navigateToMitigations = (data: any) => {
    this.router.navigate([this.authService.urlCatalog + CONFIG.routes.mo.recommendations.byModelRunId(data.OrgTreeNodeId, data.RunnableModelOrgTreeNodeId)]);
  };

  protected mitigationDrillDown = (data: DisplayData) => {
    const widgetParam = new WidgetParameter();
    widgetParam.widgetId = data.widgetId;
    widgetParam.valueSource = ValueSource.MitigationDaysEnum;
    widgetParam.valueType = ValueType.Int;
    widgetParam.displayName = data.label;
    widgetParam.intValue = -1;

    if (data.label === '7 Days') {
      widgetParam.intValue = MitigationDays.SevenDays;
    }

    if (data.label === '1 Month') {
      widgetParam.intValue = MitigationDays.OneMonth;
    }

    if (data.label === '3 Months') {
      widgetParam.intValue = MitigationDays.ThreeMonths;
    }

    if (data.label === 'More than 3 Months') {
      widgetParam.intValue = MitigationDays.MoreThanThreeMonths;
    }

    if (data.label === '12 Months') {
      widgetParam.intValue = MitigationDays.TwelveMonths;
    }

    if (data.label === '24 Months') {
      widgetParam.intValue = MitigationDays.TwentyFourMonths;
    }

    if (data.label === 'More than 24 Months') {
      widgetParam.intValue = MitigationDays.MoreThanTwentyFourMonths;
    }

    this.viewDataTableService.setItemizedDataWidgetParam.next(widgetParam);
  };

  protected setMitigationFilterParameter(widget: Widget, widgetParam: WidgetParameter, reset: boolean) {
    const paramIndex = widget.widgetItemizedDataParameters.findIndex(w => w.valueSource === ValueSource.MitigationDaysEnum);

    if (paramIndex > -1) {
      if (!reset) {
        widget.widgetItemizedDataParameters[paramIndex] = widgetParam;
        return;
      }
      widget.widgetItemizedDataParameters.splice(paramIndex, 1);
      return;
    }
    if (!reset && widgetParam.valueSource === ValueSource.MitigationDaysEnum) {
      widget.widgetItemizedDataParameters.push(widgetParam);
    }
  }

  protected createMitigationColumns(isOverdue: boolean): TableColumn[] {
    const nameColumn = new TableColumn('Asset Name', 'Name');
    nameColumn.outputType = ColumnOutputType.Link;
    nameColumn.linkClickEvent = this.navigateToMitigations;

    const dateColumn = new TableColumn('Date of Mitigation', 'DueDate');
    dateColumn.formatterPipe = DateTimeFormatterPipe;
    dateColumn.formatterPipeArgs = ['L'];

    const daysOverdueTimeToMitigationColumn = isOverdue
      ? new TableColumn('Days Overdue', 'DaysOverdue')
      : new TableColumn('Time to Mitigation (days)', 'TimeToMitigation');
    daysOverdueTimeToMitigationColumn.formatterPipe = DecimalPipe;
    daysOverdueTimeToMitigationColumn.formatterPipeArgs = ['1.0-0'];

    return [nameColumn, dateColumn, daysOverdueTimeToMitigationColumn];
  }

  protected createMitigationOverallTableHeaderColumn(isOverdue: boolean): TableColumn {
    const headerCplumnTitle = isOverdue ? 'Overdue Time' : 'Time to Mitigation';
    const headerColumn = new TableColumn(headerCplumnTitle, 'label');
    headerColumn.outputType = ColumnOutputType.Link;
    headerColumn.linkClickEvent = this.mitigationDrillDown;
    return headerColumn;
  }
}
